import React from 'react';
import BannerSection from '../containers/SaasModern/Banner';
import ProblemSection from '../containers/SaasModern/ProblemSection';
import ConsultingServices from '../containers/SaasModern/ConsultingServices';
import WhyUsSection from '../containers/SaasModern/WhyUs';
import EngagementModel from '../containers/SaasModern/EngagementModel';
import AICaseStudies from '../containers/SaasModern/AICaseStudies';
import PastWork from '../containers/SaasModern/PastWork';
import ContactSection from '../containers/SaasModern/ContactSection';
import Layout from '../containers/Layout';
import LogRocket from 'logrocket';

LogRocket.init('nb5fte/awaken-website-english');

export default () => {
  React.useEffect(() => {
    if (typeof window === 'undefined') return;
    const { hash } = window.location;
    if (!hash || hash.length < 2) return;
    const id = decodeURIComponent(hash.slice(1));
    const scrollToTarget = () => {
      const el = document.getElementById(id);
      if (!el) return;
      const NAV_OFFSET = 70;
      const y = el.getBoundingClientRect().top + window.pageYOffset - NAV_OFFSET;
      window.scrollTo({ top: y, behavior: 'smooth' });
    };
    setTimeout(scrollToTarget, 0);
  }, []);

  return (
    <Layout>
      <BannerSection />
      <ProblemSection />
      <ConsultingServices />
      <WhyUsSection />
      <EngagementModel />
      <AICaseStudies />
      <PastWork />
      <ContactSection />
    </Layout>
  );
};
